export function removeHtmlFromText(texto) {
  const elementoTemporal = document.createElement("div");
  elementoTemporal.innerHTML = texto;
  return elementoTemporal.textContent || elementoTemporal.innerText || "";
}
